import { useQuery } from '@tanstack/react-query'
import { apiFetch, getCallerAgentId, hasLiveApi } from '@/api/client'
import { isUnreachableApiError } from '@/api/unreachable'
import { agentNodeToAccount, type AgentNode } from '@/api/map/agent'
import * as api from '@/data/api'
import type { Account } from '@/data/types'
import { keys } from '@/api/hooks/shared/keys'

async function loadCreateParentFixture(): Promise<Account> {
  const session = await api.getSession()
  const account = await api.getAccount(session.accountId)
  if (!account) throw new Error('Your account could not be loaded')
  return account
}

/**
 * Parent for the Create wizard.
 * Live Keycloak → hierarchy; unreachable hierarchy → fixture parent so the
 * form shell stays visible (No data / limits from fixture). Demo → fixtures.
 */
async function loadCreateParent(): Promise<Account> {
  if (!hasLiveApi()) return loadCreateParentFixture()
  try {
    const id = getCallerAgentId()!
    const node = await apiFetch<AgentNode>(`/v1/agents/${id}`)
    return agentNodeToAccount(node)
  } catch (err) {
    if (isUnreachableApiError(err)) return loadCreateParentFixture()
    throw err
  }
}

export function useCreateParent() {
  return useQuery({
    queryKey: keys.createParent,
    queryFn: loadCreateParent,
    staleTime: 30_000,
    retry: 1,
  })
}
